import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../types'
import { CmsConverterService, defaultLinkData } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CallToActionButtonConverter extends CmsConverterService<CallToActionButtonData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      highlight: formData.st_cta_highlight?.value?.identifier === 'true',
      link: formData.st_cta_link ?? defaultLinkData,
    }
  }
}

export const CALL_TO_ACTION_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CallToActionButtonData>>('CallToActionButtonConverter')

export interface CallToActionButtonData extends ConvertedComponentData {
  link: LinkData;
  highlight: boolean;
}
